exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "app-google-maps {\n  display: block;\n  width: 100%;\n  height: 25rem; }\n\n.pin-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0.5rem 0.75rem;\n  background: #f5f5f5;\n  border-top: 0.0625rem solid #ddd; }\n\n.pin-coords {\n  font-size: 0.8125rem;\n  color: #666;\n  font-weight: bold; }\n\n.pin-actions {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0.5rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/map-pin-adjustment/map-pin-adjustment.component.scss
// module id = 1917
// module chunks = 66